import { helpers, minLength } from '@vuelidate/validators'

export const minLengthValidator = (...params: Parameters<typeof minLength>) =>
  helpers.withMessage(
    ({ $params }) => `La cantidad mínima permitida es ${$params.min}`,
    helpers.withParams({}, minLength(...params))
  )
